/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import * as queryString from 'query-string';
import { find, isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import withAuth from '../../components/hocs/withAuth';
import withStatsig from '../../components/hocs/withStatsig';
import { ClubInactivePopup, OrganizerLimitPopup, MemberLimitPopup } from '../../components/Clubs/Popups';
import UpgradeToPowerPopUp from '../../components/Upgrade/UpgradeToPowerPopUp';
import { SUBSCRIPTIONS_PATH } from '../../components/hooks/useStartPowerCheckout';
import UpgradeToProClubPopUp from '../../components/Upgrade/UpgradeToProClubPopUp';
import * as actions from '../../actions/club-actions';
import * as messagingActions from '../../actions/messaging-actions';
import * as SplashComponents from '../../components/Clubs/Splash';

import { isActive, isPersonalClub, isClubAdminOrOwner, isClubAdminOrMember, getClubNameDisplay } from '../../utils/clubs';
import { SortType } from '../../components/ColumnHeader';
import {
    WelcomePopUp,
    OrganizerWelcomePopUp,
} from '../../components/PopUps';
import { uploadTempPhoto, clearTempPhoto } from '../../actions/upload-actions';

import { isLoginPopUpNeeded, userParams, titles } from '../../components/PopUps/LoginPopUpWrapper/LoginPopUp/utils';
import * as loginPopUpActions from '../../actions/login-popup-actions';
import config from '../../../config';

import PlayersGroupHeader from '../../components/Clubs/ClubProfile/ClubProfileHeader/PlayersGroupHeader';
import PlayersGroupContent from '../../components/Clubs/ClubProfile/PlayersGroupContent';

import { removeQueryParam } from '../../utils';
import head from '../../components/Meta';
import InviteMembersModal from '../../components/Modals/InviteMembersModal';
import { showErrorPopup } from '../../actions/notification-actions';

import { ClubMenuOptions } from './constants';
import styles from './club.scss';

const _ = { find, isEmpty };

class PlayersGroupProfilePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPowerPopup: false,
            showProClubPopup: false,
            powerPopupType: null,
            handlePowerSuccess: null,
            showMemberLimitPopup: false,
            showOrganizerLimitPopup: false,
            showInactivePopup: false,
            adminSplash: null,
            showAdminSplash: false,
            redirect: false,
            redirectUrl: '/',
            membersTabState: {
                adminViewType: 'members',
                memberViewType: 'current',
                requestViewType: 'Pending',
                inviteViewType: 'pending',
                sortParam: 'membershipType',
                sortType: SortType.ASC,
            },
            actionPerformed: false,
        };
        this.createEvent = this.createEvent.bind(this);
        this.inviteMembers = this.inviteMembers.bind(this);
        this.showAdminSplash = this.showAdminSplash.bind(this);
        this.handlePowerSuccess = this.handlePowerSuccess.bind(this);
        this.handleProClubSuccess = this.handleProClubSuccess.bind(this);
        this.handlePowerSuccessForPayment = this.handlePowerSuccessForPayment.bind(this);
        this.approveOrRejectRequest = this.approveOrRejectRequest.bind(this);
        this.handleRequestToJoinClick = this.handleRequestToJoinClick.bind(this);
        this.showUpgradeToProClubCollegePopup = this.showUpgradeToProClubCollegePopup.bind(this);
        this.showLearnMoreUtrCollegePopup = this.showLearnMoreUtrCollegePopup.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
        this.onSelected = this.onSelected.bind(this);
        this.onCreateEventClick = this.onCreateEventClick.bind(this);
        this.showOrganizerLimitPopup = this.showOrganizerLimitPopup.bind(this);
        this.closePlayerGroupWelcomePopup = this.closePlayerGroupWelcomePopup.bind(this);
        this.handleShowLoginPopUp = this.handleShowLoginPopUp.bind(this);
        this.getReferralPopupSetttings = this.getReferralPopupSetttings.bind(this);
        this.onInvitePlayersClick = this.onInvitePlayersClick.bind(this);
        this.closeInviteMembersModal = this.closeInviteMembersModal.bind(this);
        this.updateActionPerformed = this.updateActionPerformed.bind(this);

        this.showUpgradeToPowerPopup = this.showUpgradeToPowerPopup.bind(this);
    }

    componentDidMount() {
        const parsed = queryString.parse(this.props.location.search);
        if (parsed.member) {
            this.showAdminSplash(<SplashComponents.YouAreMember />, 3000);
        } else if (this.props.club.isClubCreated) {
            this.showAdminSplash(<SplashComponents.GroupCreated />, 3000);
        } else if (this.props.club.isClubUpdated) {
            this.showAdminSplash(<SplashComponents.GroupUpdated />, 3000);
        } else if (this.props.club.membersInvited) {
            this.showAdminSplash(<SplashComponents.MembersInvited />, 3000);
        } else if (this.props.club.addedAdmins) {
            this.showAdminSplash(<SplashComponents.AdminsAdded />, 3000);
        }
        this.props.clearSplashProps();
        if (parsed.welcome) {
            this.setState({ showOrganizerWelcomeScreen: true });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.props.club.isLoading && !nextProps.club.isLoading && nextProps.match.params.clubId !== this.props.club.clubId) {
            this.props.setClubId(nextProps.match.params.clubId);
        }
    }

    componentDidUpdate() {
        const parsed = queryString.parse(this.props.location.search);
        const { clubDetails } = this.props.club;
        const { user } = this.props.auth;
        if (parsed.showPopup && !this.state.actionPerformed && clubDetails && user) {
            this.handleShowLoginPopUp(parsed.type);
            this.updateActionPerformed();
        }
    }

    onSelected(selected) {
        const { user } = this.props.auth;
        const { clubId } = this.props.match.params;
        const { clubType } = this.props;
        const { clubDetails } = this.props.club;
        const clubTierType = clubDetails.tierType;

        switch (selected.value) {
            case 1:
                if (!isActive(clubDetails)) {
                    this.setState({ showInactivePopup: true });
                } else {
                    this.inviteMembers(clubType);
                }
                break;
            case 2:
                this.props.history.push(`/${clubType}/${clubId}`);
                this.setState({
                    redirect: true,
                    redirectUrl: `/${clubType}/${clubId}/organizers/add`,
                });
                break;
            case 3:
                if (!clubDetails.isTournamentClub && !clubDetails.isPro && !clubDetails.isSpecial && !clubTierType.isHighSchool && !user.isPowered) {
                    this.setState({ showPowerPopup: true, powerPopupType: 'personal_club_paid_event', handlePowerSuccess: () => { this.handlePowerSuccessForPayment(clubType); } });
                    break;
                }
                this.props.history.push(`/${clubType}/${clubId}`);
                this.setState({
                    redirect: true,
                    redirectUrl: `/${clubType}/${clubId}/payment`,
                });
                break;
            case 4:
                this.props.history.push(`/${clubType}/${clubId}/edit`);
                break;
            case 6:
                this.props.removeClubProfilePhoto(clubId);
                break;
            case 7:
                this.props.history.push(`/clubs/${clubId}/add-members`);
                break;
            case 8:
                this.props.history.push(`/${clubType}/${clubId}/post-score`);
                break;
            case 9:
                window.open(`${config.userSiteHost}/teammatch`, '_blank');
                break;
            case 10:
                this.createDemoEvent();
                break;
            case 11:
                this.setState({
                    // showClubReferralCodePopup: true,
                });
                break;
            case 12:
                this.setState({
                    // showHSReferralCodePopup: true,
                });
                break;
            case ClubMenuOptions.CLUB_REFERRALS:
                this.props.history.push(`/refer-friends/club/${clubId}`);
                break;
            default:
                // Do nothing
                break;
        }
    }

    onCreateEventClick() {
        const { clubDetails } = this.props.club;
        const { clubType } = this.props;
        if (!isActive(clubDetails)) {
            this.setState({ showInactivePopup: true });
        } else if (clubDetails && isClubAdminOrOwner(clubDetails) && isPersonalClub(clubDetails.tierType)) {
            this.schedulePlay(clubType);
        } else {
            this.createEvent(clubType);
        }
    }

    onInvitePlayersClick() {
        this.setState({
            showInviteMembersModal: true,
        });
    }

    getReferralPopupSetttings(referrerBonus, refereeBonus) {
        // assuming referrer Bonus is UTR Sports credit Referee Bonus is Discount always
        if (referrerBonus && (referrerBonus.amount > 0)) {
            if (refereeBonus && (refereeBonus.amount > 0)) {
                return {
                    title: 'Invite Players',
                    subTitle: `Earn $${referrerBonus.amount} credit when you refer a player who becomes a Power User and they will receive a $${refereeBonus.amount} discount.`,
                    showCreditBalance: true,
                };
            }
            return {
                title: 'Invite Players',
                subTitle: `Earn $${referrerBonus.amount} credit when you refer a player who becomes a Power User.`,
                showCreditBalance: true,
            };
        }
        if (refereeBonus && (refereeBonus.amount > 0)) {
            return {
                title: 'Invite Players',
                subTitle: `Refer your players to sign up for a Power Subscription and they will receive a $${refereeBonus.amount} discount`,
                showCreditBalance: false,
            };
        }
        return {
            title: 'Invite Players',
            subTitle: 'Refer your players to sign up for a Power Subscription',
            showCreditBalance: false,
        };
    }

    updateActionPerformed() {
        this.setState({
            actionPerformed: true,
        });
    }

    handleProClubSuccess() {
        setTimeout(() => {
            window.location.reload();
            // this.setState({showProClubPopup: false})
        }, 3000);
    }

    handlePowerSuccess() {
        setTimeout(() => {
            window.location.reload();
            // this.setState({showPowerPopup: false})
        }, 3000);
    }

    handlePowerSuccessForPayment(clubType) {
        const { clubId } = this.props.club;
        setTimeout(() => {
            this.props.history.push(`/${clubType}/${clubId}/payment`);
        }, 3000);
    }

    showAdminSplash(splashComponent, timeout) {
        this.setState({
            adminSplash: splashComponent,
            showAdminSplash: true,
        });
        if (timeout) {
            setTimeout(() => {
                this.setState({
                    adminSplash: null,
                    showAdminSplash: false,
                });
            }, timeout);
        }
    }

    closePlayerGroupWelcomePopup() {
        removeQueryParam('showPlayerGroupWelcomePopup', this.props);
    }

    createEvent(clubType) {
        this.setState({
            redirect: true,
            redirectUrl: `/events/create?clubId=${this.props.club.clubId}`,
        });
        this.props.history.push(`/${clubType}/${this.props.club.clubId}`);
    }

    schedulePlay(clubType) {
        if (this.props.club.clubDetails?.tmsEvents.length > 0) {
            this.setState({
                redirect: true,
                redirectUrl: `/events/create-group-play?clubId=${this.props.club.clubId}`,
            });
        } else {
            this.setState({
                redirect: true,
                redirectUrl: `/events/create-group-play?clubId=${this.props.club.clubId}&flow=personel_club_event_create`,
            });
        }
        this.props.history.push(`/${clubType}/${this.props.club.clubId}`);
    }

    inviteMembers(members) {
        const membersToInvite = [];
        members.forEach(member => {
            if (member.email) {
                membersToInvite.push(member);
            } else if (member.memberId) {
                membersToInvite.push({
                    memberId: member.memberId,
                });
            }
        });
        this.props.inviteMembersToClub(membersToInvite);
        this.setState({
            showInviteMembersModal: false,
        });
    }

    approveOrRejectRequest(value, request) {
        const { clubDetails, isLoading } = this.props.club;
        const { user } = this.props.auth;
        if (value === 'accept') {
            if (!isActive(clubDetails)) {
                this.setState({ showInactivePopup: true });
                return;
            }
            if (clubDetails.availableMemberSlots === 0) {
                if (user.isPowered) {
                    this.setState({ showMemberLimitPopup: true });
                } else {
                    this.setState({ showPowerPopup: true, handlePowerSuccess: this.handlePowerSuccess });
                }
                return;
            }
        }
        if (!isLoading) {
            this.props.approveOrRejectRequest(value, request);
        }
    }

    handleShowLoginPopUp(type) {
        let actionMethod;
        const splitArray = type.split('-');
        switch (splitArray[0]) {
            case 'requesttojoin':
                actionMethod = () => this.handleRequestToJoinClick();
                break;
            case 'tab':
                actionMethod = () => this.handleTabClick(null, parseInt(splitArray[1]));
                break;
            default:
                break;
        }
        const userParamsNeeded = [
            userParams.CLAIMED_PROFILE,
        ];
        if (isLoginPopUpNeeded(this.props.auth, userParamsNeeded)) {
            const popupData = {
                userParamsNeeded,
                titles: titles.REQUEST_TO_JOIN_CLUB,
                performAction: actionMethod,
                type, // should be sent back as query while redirecting from facebook to perform proper action
            };
            this.props.showLoginPopUp(popupData);
        } else if (actionMethod) {
            actionMethod();
        }
    }

    showUpgradeToPowerPopup() {
        this.setState({ showPowerPopup: true, handlePowerSuccess: this.handlePowerSuccess });
    }

    handleRequestToJoinClick() {
        const { clubDetails } = this.props.club;
        const { user } = this.props.auth;
        if (clubDetails?.isSpecial) {
            if (!user.isPowered) {
                this.setState({
                    showPowerPopup: true,
                    powerPopupType: 'premium_clubs',
                    handlePowerSuccess: this.handlePowerSuccess,
                });
            } else {
                this.props.requestToJoin();
            }
        } else if (!clubDetails.tierType.isTournamentClub) {
            if (clubDetails.currentMember.role === 'Member' || clubDetails.currentMember.role === 'Follower') {
                this.props.requestToUnfollow();
            } else {
                this.props.requestToJoin();
            }
        }
    }

    showUpgradeToProClubCollegePopup() {
        this.setState({ showProClubPopup: true });
    }

    showLearnMoreUtrCollegePopup() {
        // this.setState({ showLearnMoreUtrCollegePopup: true });
    }

    async sendMessage(recipient) {
        if (!recipient.displayName && recipient.firstName && recipient.lastName) {
            // eslint-disable-next-line no-param-reassign
            recipient.displayName = `${recipient.firstName} ${recipient.lastName}`;
        }

        const { auth } = this.props;

        if (recipient?.memberId && auth?.user?.id !== recipient.memberId) {
            this.props.msgSetNewConv(true);
            this.props.msgAddRecipient(recipient);
            this.props.history.push(`/inbox`);
        }
    }

    createDemoEvent() {
        const { clubType } = this.props;
        this.setState({
            redirect: true,
            redirectUrl: `/events/create?clubId=${this.props.club.clubId}&demoEvent=true`,
        });
        this.props.history.push(`/${clubType}/${this.props.club.clubId}`);
    }

    closeInviteMembersModal() {
        this.setState({
            showInviteMembersModal: false,
        });
    }

    showOrganizerLimitPopup(type) {
        this.setState({ showOrganizerLimitPopup: true, organizerLimitType: type });
    }

    render() {
        const { auth, checkGate, featureGates } = this.props;
        const { membersTabState } = this.state;
        const user = (this.props.auth?.user) || {};
        const clubReferralsEnabled = checkGate(featureGates.REFERRAL_SYSTEM);
        const { clubDetails, clubId, schoolDetails, schoolDetailsState, tmsEventsFetchState } = this.props.club;
        const clubStatus = clubDetails?.statusType;
        const isSchool = clubDetails?.clubHasSchool;
        const clubIdInUrl = this.props.match.params.clubId;
        const { clubType } = this.props;
        const clubTierType = (clubDetails?.tierType) || {};

        const { showPlayerGroupWelcomePopup } = queryString.parse(this.props.location.search);

        // rewrite route if type mistmatch
        if (!_.isEmpty(clubTierType) && clubId === clubIdInUrl) {
            if (clubType !== 'groups') {
                if (isPersonalClub(clubTierType)) {
                    return <Redirect to={`/groups/${clubId}`} />;
                }
            }
        }

        const isAdminOrOwner = isClubAdminOrOwner(clubDetails);
        const isPersonal = clubDetails && isPersonalClub(clubDetails.tierType);
        const isAdminOrMember = isClubAdminOrMember(clubDetails);
        const directAddClubMembersEnabled = checkGate(featureGates.DIRECT_ADD_CLUB_MEMBERS);

        const menuList = [
            {
                label: 'Edit profile',
                value: 4,
                showOption: true,
            },
            {
                label: 'Add Providers',
                value: 2,
                showOption: clubDetails?.canHaveMultipleAdmins && !clubDetails.isEnterprise && !clubDetails.isPro,
            },
            {
                label: 'Invite Members',
                value: 1,
                showOption: false,
            },
            {
                label: 'Event Payments Account',
                value: 3,
                showOption: !isPersonal,
            },
            {
                label: 'Remove Profile Photo',
                value: 6,
                showOption: isSchool && isAdminOrOwner,
            },
            {
                label: 'Add Members',
                value: 7,
                showOption: directAddClubMembersEnabled && (clubDetails?.isEnterprise || clubDetails?.isPro),
            },
            {
                label: 'Post Scores',
                value: 8,
                showOption: false,
            },
            {
                label: 'Enter Scores - old tool',
                value: 9,
                showOption: false,
            },
            {
                label: 'Create Demo Event',
                value: 10,
                showOption: clubDetails?.demoEventCount === 0 && !isPersonal,
            },
            {
                label: 'Power Upgrade Link',
                value: 11,
                showOption: clubReferralsEnabled && (clubDetails.isEnterprise) && !isPersonal,
            },
            {
                label: 'Invite School Coaches',
                value: 12,
                showOption: clubReferralsEnabled && clubTierType.isHighSchool && isAdminOrOwner,
            },
            {
                label: 'Club Referrals',
                value: ClubMenuOptions.CLUB_REFERRALS,
                showOption: clubReferralsEnabled && isAdminOrOwner,
            },
        ];
        const { schoolProfile, name, description, id } = clubDetails || {};
        const displayName = clubTierType && getClubNameDisplay(clubTierType, schoolProfile, name);

        return (
            <div>
                {head({
                    title: displayName ? `UTR Sports | ${displayName}` : config.defaultTitle,
                    description,
                    url: `${config.appHost}/clubs/${id}`,
                    keywords: 'Tennis Clubs, Tennis Events, UTR Sports Tournaments',
                    image: `https://www.${config.siteBaseUrl}/img/utr_sports/utr-sports-logo.svg`,
                    imageWidth: '930',
                    imageHeight: '395',
                })}
                {clubDetails && (
                    <div className={`${styles.clubProfile}`}>
                        {this.state.showAdminSplash && (
                            <div className={`${styles.section} sub-header admin-splash bg-teal`}>
                                <div className={`container bg-transparent`}>
                                    <div className="row">
                                        <div className={`col d-flex align-items-center justify-content-center text-center`}>
                                            <h6>
                                                {this.state.adminSplash}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <PlayersGroupHeader
                            menuOptions={menuList.filter(option => option.showOption)}
                            clubDetails={clubDetails}
                            isAdminOrOwner={isAdminOrOwner}
                            isAdminOrMember={isAdminOrMember}
                            onSelected={this.onSelected}
                            clubType={clubType}
                            onCreateEventClick={this.onCreateEventClick}
                            onInvitePlayersClick={this.onInvitePlayersClick}
                            handleRequestToJoinClick={() => {
                                this.handleShowLoginPopUp('requesttojoin');
                            }}
                            removeBannerPhoto={this.props.removeBannerPhoto}
                            openPendingRequests={this.openPendingRequests}
                            showUpgradeToProClubCollegePopup={this.showUpgradeToProClubCollegePopup}
                        />
                        <div className={`${styles.content}`}>
                            <div className={`container`}>
                                <PlayersGroupContent
                                    clubDetails={clubDetails}
                                    auth={auth}
                                    isAdminOrOwner={isAdminOrOwner}
                                    clubType={clubType}
                                    removeSponsorLogo={this.props.removeSponsorLogo}
                                    tmsEventsFetchState={tmsEventsFetchState}
                                    schoolDetailsState={schoolDetailsState}
                                    schoolDetails={schoolDetails}
                                    handleTabClick={this.handleTabClick}
                                    onUpgradeToCollegeClick={this.onUpgradeToCollegeClick}
                                    onCreateEventClick={this.onCreateEventClick}
                                    sendMessage={this.sendMessage}
                                    clubMemberRoles={this.props.coreUI.types.clubMemberRole}
                                    membersTabState={membersTabState}
                                    checkGate={checkGate}
                                    featureGates={featureGates}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {this.state.redirect && (
                    <Redirect to={this.state.redirectUrl} />
                )}
                <ClubInactivePopup
                    show={this.state.showInactivePopup}
                    close={() => this.setState({ showInactivePopup: false })}
                    status={clubStatus ? clubStatus.value : null}
                    clubTierType={clubTierType}
                />
                <OrganizerLimitPopup
                    show={this.state.showOrganizerLimitPopup}
                    close={() => this.setState({ showOrganizerLimitPopup: false, organizerLimitType: null })}
                    type={this.state.organizerLimitType}
                />
                <MemberLimitPopup
                    show={this.state.showMemberLimitPopup}
                    close={() => this.setState({ showMemberLimitPopup: false })}
                />
                {this.state.showPowerPopup && this.props.auth?.user?.hasPastDueSubscription && (
                    <Redirect to={SUBSCRIPTIONS_PATH} />
                )}
                {this.state.showPowerPopup && !this.props.auth?.user?.hasPastDueSubscription && (
                    <UpgradeToPowerPopUp
                        type={this.state.powerPopupType}
                        onCloseClick={() => this.setState({ showPowerPopup: false })}
                        onSuccess={this.state.handlePowerSuccess}
                    />
                )}
                {this.state.showProClubPopup &&
                    (
                        <UpgradeToProClubPopUp
                            data-testid="modal.players-group.upgrade-pro-club"
                            skipIntro={true}
                            onCloseClick={() => this.setState({ showProClubPopup: false })}
                            onSuccess={this.handleProClubSuccess}
                            clubId={clubId}
                            clubTierType={clubTierType}
                            titleInfoOnClick={this.showLearnMoreUtrCollegePopup}
                        />
                    )}
                {this.state.showOrganizerWelcomeScreen && isAdminOrOwner && !clubTierType.isHighSchool && (
                    <OrganizerWelcomePopUp
                        onCloseClick={(ev) => {
                            this.setState({
                                showOrganizerWelcomeScreen: false,
                            });
                        }}
                        onCtaClick={(ev) => {
                            this.setState({
                                showOrganizerWelcomeScreen: false,
                            });
                            this.crateEvent(clubType);
                        }}
                        memberName={user.firstName}
                    />
                )}

                {showPlayerGroupWelcomePopup && (
                    <WelcomePopUp
                        dangerouslySetInnerHTML={true}
                        welcomeTitles={{
                            title: 'Arrange tennis activity for your group!',
                            subTitle: 'Invite group members and create tennis events',
                            description: 'Connect and schedule casual or competitive play with up to 25 of your regular tennis friends. If you’re trying to organize a competitive tournaments, please become a UTR Sports Organizer <a href="/create-event" target="_blank">here</a>',
                        }}
                        onCloseClick={(ev) => {
                            this.closePlayerGroupWelcomePopup();
                        }}
                        onCtaClick={(ev) => {
                            this.closePlayerGroupWelcomePopup();
                        }}
                    />
                )}

                {this.state.showInviteMembersModal && (
                    <InviteMembersModal
                        title={`Invite Players to Your Group`}
                        onCloseClick={this.closeInviteMembersModal}
                        onActionClick={this.inviteMembers}
                    />
                )}

            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setClubId: (clubId) => {
            dispatch(actions.setClubId(clubId, true));
        },
        getClubTMSEventsList: () => {
            dispatch(actions.getClubEventsList());
        },
        getClubResults: () => {
            dispatch(actions.getClubResults());
        },
        updateMemberRole: (memberId, memberRole) => {
            dispatch(actions.updateMemberRole(memberId, memberRole));
        },
        updateMemberType: (memberId, isPhysicalMember) => {
            dispatch(actions.updateMemberType(memberId, isPhysicalMember));
        },
        updateClubMemberPower: (memberId, isPhysicalMember) => {
            dispatch(actions.updateClubMemberPower(memberId, isPhysicalMember));
        },
        clearSplashProps: () => {
            dispatch(actions.clearSplashProps());
        },
        uploadPhoto: (file) => dispatch(uploadTempPhoto(file)),
        clearTempPhoto: (usePng) => dispatch(clearTempPhoto(usePng)),
        cropClubBanner: (clubId, values) => dispatch(actions.cropClubBanner(clubId, values)),
        removeBannerPhoto: (clubId) => dispatch(actions.removeBannerPhoto(clubId)),
        requestToJoin: () => {
            dispatch(actions.requestToJoin());
        },
        requestToUnfollow: () => {
            dispatch(actions.requestToUnfollow());
        },
        approveOrRejectRequest: (value, member) => {
            dispatch(actions.approveOrRejectRequest(value, member));
        },
        cropClubSponsorLogo: (clubId, values) => dispatch(actions.cropClubSponsorLogo(clubId, values)),
        removeSponsorLogo: (clubId) => dispatch(actions.removeSponsorLogo(clubId)),
        resendInvite: (value, clubId, invite) => {
            dispatch(actions.resendInvite(value, clubId, invite));
        },
        deleteInvite: (value, clubId, invite) => {
            dispatch(actions.deleteInvite(value, clubId, invite));
        },
        showLoginPopUp: (data) => dispatch(loginPopUpActions.showLoginPopUp(data)),
        updatePlayer: (playerData) => dispatch(actions.updatePlayer(playerData)),
        cropClubProfilePhoto: (clubId, values) => dispatch(actions.cropClubProfilePhoto(clubId, values)),
        removeClubProfilePhoto: (clubId) => dispatch(actions.removeProfilePhoto(clubId)),
        changeResultsType: (resultsType) => {
            dispatch(actions.changeResultsType(resultsType));
        },
        showError: (msg) => dispatch(showErrorPopup({ error: msg })),
        msgAddRecipient: (member) => dispatch(messagingActions.addRecepient({ member })),
        msgSetNewConv: (member) => dispatch(messagingActions.setNewConv({ member })),
        closePowerPopup: () => dispatch(messagingActions.closePowerPopup()),
        inviteMembersToClub: (members) => dispatch(actions.inviteMembersToClub(members)),
    };
}

function mapStateToProps({ auth, search, header, club, uploads, coreUI, componentConfig }) {
    return { auth, search, header, club, uploads, coreUI, componentConfig };
}

PlayersGroupProfilePage.propTypes = {
    club: PropTypes.shape({
        clubId: PropTypes.string.isRequired,
        clubDetails: PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            description: PropTypes.string,
            statusType: PropTypes.shape({
                value: PropTypes.string,
            }),
            tierType: PropTypes.shape({
                id: PropTypes.string,
                name: PropTypes.string,
                isCollege: PropTypes.bool,
                isHighSchool: PropTypes.bool,
                isTournamentClub: PropTypes.bool,
                isPersonalClub: PropTypes.bool,
            }),
            clubHasSchool: PropTypes.bool,
            isEnterprise: PropTypes.bool,
            isPro: PropTypes.bool,
            isSpecial: PropTypes.bool,
            currentMember: PropTypes.shape({
                role: PropTypes.string,
            }),
            canHaveMultipleAdmins: PropTypes.bool,
            referralCode: PropTypes.string,
            demoEventCount: PropTypes.number,
            tmsEvents: PropTypes.arrayOf(PropTypes.object),
            availableMemberSlots: PropTypes.number,
        }),
        isLoading: PropTypes.bool,
        isClubCreated: PropTypes.bool,
        isClubUpdated: PropTypes.bool,
        membersInvited: PropTypes.bool,
        addedAdmins: PropTypes.bool,
        schoolDetails: PropTypes.object,
        schoolDetailsState: PropTypes.object,
        tmsEventsFetchState: PropTypes.object,
    }).isRequired,
    featureGates: PropTypes.shape({
        DIRECT_ADD_CLUB_MEMBERS: PropTypes.string,
        REFERRAL_SYSTEM: PropTypes.string,
    }).isRequired,
    checkGate: PropTypes.func.isRequired,
    auth: PropTypes.shape({
        user: PropTypes.shape({
            id: PropTypes.string,
            firstName: PropTypes.string,
            lastName: PropTypes.string,
            isPowered: PropTypes.bool,
            isProClubHeadOrganizer: PropTypes.bool,
        }),
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
        search: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            clubId: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    clubType: PropTypes.string.isRequired,
    coreUI: PropTypes.shape({
        types: PropTypes.shape({
            messagingConversationContextType: PropTypes.array,
            clubMemberRole: PropTypes.array,
        }),
    }).isRequired,
    setClubId: PropTypes.func.isRequired,
    clearSplashProps: PropTypes.func.isRequired,
    removeBannerPhoto: PropTypes.func.isRequired,
    requestToJoin: PropTypes.func.isRequired,
    requestToUnfollow: PropTypes.func.isRequired,
    approveOrRejectRequest: PropTypes.func.isRequired,
    removeSponsorLogo: PropTypes.func.isRequired,
    showLoginPopUp: PropTypes.func.isRequired,
    removeClubProfilePhoto: PropTypes.func.isRequired,
    msgSetNewConv: PropTypes.func.isRequired,
    inviteMembersToClub: PropTypes.func.isRequired,
};

export default withRouter(withStatsig(withAuth(connect(mapStateToProps, mapDispatchToProps)(PlayersGroupProfilePage))));
